export enum StreamChannelType {
  General = 'General',
  Tmdx = 'Tmdx',
  OrganManagement = 'OrganManagement',
  Quote = 'Quote',
  Logistics = 'Logistics',
  OpoGeneral = 'OpoGeneral',
}
